import React, { forwardRef, ReactNode } from 'react';
import { getWrapStyle, getModuleElementId, getModuleCode } from 'mod/featureV2/utils';
import { FeatureHeader } from 'mod/featureV2/FeatureHeader';
import { IFeatureBase, IFeatureProps } from 'mod/featureV2/interface';
import cn from 'classnames';
import { isDark } from 'base/utils/color';

export type IFeatureContainerProps = IFeatureProps<IFeatureBase> & {
    children?: ReactNode;
    showHeader?: boolean;
}

export const FeatureContainer = forwardRef<HTMLDivElement, IFeatureContainerProps>((props, ref) => {
    const {
        feature,
        children,
        showHeader = true,
        renderContainer,
        id: propsId,
        className: propsClassName,
        style,
    } = props;

    const {
        className: featureClassName,
        moduleId,
        background,
        space,
        vars,
        theme,
    } = feature || {};

    const {
        containerClassName,
        bodyClassName
    } = theme || {};

    const containerStyle = getWrapStyle({ background, space, vars });
    const themeClass = background?.color
        ? isDark(background?.color) ? 'g-feature-dark' : 'g-feature-light'
        : '';

    return (
        <div
            ref={ref}
            id={moduleId ? getModuleElementId(moduleId) : (propsId || void 0)}
            data-t-mod={moduleId ? getModuleCode(moduleId) : void 0}
            className={cn(
                'g-feature-container',
                propsClassName,
                featureClassName,
                containerClassName,
                themeClass,
            )}
            style={{ ...containerStyle, ...style }}
        >
            {typeof renderContainer === 'function' ? renderContainer(feature, children) : (
                <>
                    {showHeader && <FeatureHeader feature={feature}/>}

                    {!bodyClassName ? children : (
                        <div className={bodyClassName}>
                            {children}
                        </div>
                    )}
                </>
            )}
        </div>
    )
});